import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { DefaultLayoutComponent } from './layout/default-layout.component';

export const appRoutes: Routes = [
  { path: '', component: DefaultLayoutComponent, data: { title: 'Home' },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)},
      { path: 'client', loadChildren: () => import('./client/client.module').then(m => m.ClientModule)},
      { path: 'job', loadChildren: () => import('./job/job.module').then(m => m.JobModule)},
      { path: 'planning', loadChildren: () => import('./planning/planning.module').then(m => m.PlanningModule)},
      { path: 'billing', loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule)},
      { path: 'reports', loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule)},
      { path: 'manageprofile', loadChildren: () => import('./manageprofile/manageprofile.module').then(m => m.ManageprofileModule)},
      { path: 'document', loadChildren: () => import('./document/document.module').then(m => m.DocumentModule)},
      { path: 'dms', loadChildren: () => import('./dms/dms.module').then(m => m.DmsModule)},
      { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)},
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(appRoutes, {
    preloadingStrategy: PreloadAllModules,
    // Don't perform initial navigation in iframes or popups
    //initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
})],
exports: [RouterModule]
})
export class AppRoutingModule { }
